import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'gatsby';
// import config from '../utils/config';
import SocialIcons from './SocialIcons';
import ScrollButton from './ScrollButton';

const Container = styled.footer`
  padding-bottom: 0;
  .columns.is-multiline {
    border-bottom: 1px solid #afb1bd;
  }
  .image.is-96x96 {
    height: 53px;
    width: 113px;
    margin: 0 0 0 20px;
  }
  background-color: #f9f9fb;
  position: relative;
  a {
    :hover {
      color: ${(props) => props.theme.textColor} !important;
    }
  }

  li {
    margin-bottom: 1rem;
  }
`;

const Address = styled.address`
  font-size: 17px;
`;

const Heading = styled.p`
  margin-bottom: 1rem;
`;

const NavItems = [
  { id: 1, name: 'About us', url: '/page/about-us' },
  { id: 2, name: 'Delivery Information', url: '/page/delivery-information' },
  { id: 3, name: 'Gift Vouchers', url: '/coupons' },
  { id: 4, name: 'Blog', url: '/blog' },
];

const Info = [
  { id: 1, name: 'Exchanges & Returns', url: '/page/return-policy' },
  { id: 2, name: 'Terms and Conditions', url: '/page/terms-and-condition' },
  { id: 3, name: 'Privacy Policy', url: '/page/privacy-policy' },
];

const Footer = ({ home }) => {
  return (
    <Container className="section ">
      <div className="container">
        <div className="columns is-multiline">
          <div className="column  has-text-black">
            <Link to="/">
              <figure className="image is-96x96">
                <img src="/images/frontier.png" alt="" />
              </figure>
            </Link>
            <SocialIcons data={home} />
            {/*
            <ContactAddress /> */}
          </div>
          <div className="column has-text-white">
            <Heading className="is-uppercase is-size-5 has-text-weight-semibold">
              Frontier
            </Heading>
            <ul>
              {NavItems.map((item) => (
                <li key={item.id}>
                  <Link to={item.url} className="has-text-black">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="column has-text-black">
            <Heading className="is-uppercase is-size-5 has-text-weight-semibold">
              Our Information
            </Heading>
            <ul>
              {Info.map((item) => (
                <li key={item.id}>
                  <Link to={item.url} className="has-text-black">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="column has-text-black is-4">
            <Heading className="is-uppercase is-size-5 has-text-weight-semibold">
              Contact
            </Heading>
            <Address>
              <h1>{home.address}</h1>
              <br />
              <h1>
                Tel: <a href={`tel:${home.telephone}`}>{home.telephone}</a>
              </h1>
              <br />
              <h1>
                Email: <a href={`mailto:${home.email}`}>{home.email}</a>
              </h1>
            </Address>
          </div>
        </div>
      </div>

      <ScrollButton scrollStepInPx="50" delayInMs="16.66" />
    </Container>
  );
};

Footer.defaultProps = {
  home: {},
};

Footer.propTypes = {
  home: PropTypes.object,
};

export default Footer;
